<template>
  <VModal ref="modal" @modal:hidden="$emit('closed')">
    <BaseCard
      v-if="loading"
      class="w-full h-full flex flex-col items-center justify-center"
      @click.stop
    >
      <BaseCardBody>
        <Loader />
      </BaseCardBody>
    </BaseCard>
    <BaseCard v-else-if="resolved" class="w-full h-full flex flex-col" @click.stop>
      <BaseCardHeader>
        <div class="flex">
          <div class="flex-none ml-auto">
            <button
              type="button"
              class="bg-white rounded-full text-gray-400 hover:text-gray-500 p-1 -mr-1 focus:outline-none focus:bg-gray-100"
              @click="$refs.modal.close()"
            >
              <span class="sr-only">Close</span>
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </BaseCardHeader>
      <div class="flex-1 overflow-hidden p-2">
        <ConversationMessages ref="conversationMessages" :conversation-id="conversationId" />
      </div>
      <BaseCardFooter gray>
        <ConversationMessageComposer :conversation-id="conversationId" @created="handleCreated" />
      </BaseCardFooter>
    </BaseCard>
    <BaseCard v-else class="w-full h-full flex flex-col items-center justify-center" @click.stop>
      <BaseCardBody> Something Went Wrong ! </BaseCardBody>
    </BaseCard>
  </VModal>
</template>

<script>
import BaseCard from 'Components/BaseCard.vue';
import ConversationMessages from './ConversationMessages.vue';
import ConversationMessageComposer from './ConversationMessageComposer.vue';

export default {
  components: {
    BaseCard,
    ConversationMessageComposer,
    ConversationMessages,
  },
  props: {
    conversationId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  computed: {
    conversation() {
      return this.$store.state.entities.conversations.byId[this.conversationId];
    },
  },
  created() {
    this.fetchConversation();
  },
  methods: {
    async fetchConversation() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/conversations/read', {
          conversationId: this.conversationId,
          query: {
            include: 'participants.participable',
          },
        });
        this.resolved = true;
      } catch (error) {
        this.rejected = true;
      } finally {
        this.loading = false;
      }
    },
    handleCreated() {
      if (!this.$refs.conversationMessages) {
        return;
      }
      this.$refs.conversationMessages.scrollToBottom();
    },
  },
};
</script>
